/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
const localStorageService = (function () {
  let service;

  function getService() {
    if (!service) {
      service = this;
      return service;
    }
    return service;
  }

  const removeAllItemsLocalStorage = () => {
    localStorage.removeItem('@UltragazEmpresarial:customerCode');
    localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
    localStorage.removeItem('@UltragazEmpresarial:customerName');
    localStorage.removeItem('@UltragazEmpresarial:refreshToken');
    localStorage.removeItem('@UltragazEmpresarial:accessToken');
    localStorage.removeItem('@UltragazEmpresarial:userName');
    localStorage.removeItem('@UltragazEmpresarial:document');
    localStorage.removeItem('@UltragazEmpresarial:customerId');
    localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
    localStorage.removeItem('@UltragazEmpresarial:loginEmail');
    localStorage.removeItem('@UltragazEmpresarial:customerAddressLine');
    localStorage.removeItem('@UltragazEmpresarial:userCustomerRelationshipId');
    localStorage.removeItem('@UltragazEmpresarial:customerType');
  };

  async function clearStorage() {
    removeAllItemsLocalStorage();
  }

  async function setToken(oauthBody) {
    await localStorage.setItem(
      '@UltragazEmpresarial:accessToken',
      oauthBody.access_token
    );
    await localStorage.setItem(
      '@UltragazEmpresarial:refreshToken',
      oauthBody.refresh_token
    );
  }

  async function getAccessToken() {
    return await localStorage.getItem('@UltragazEmpresarial:accessToken');
  }

  async function getRefreshToken() {
    return await localStorage.getItem('@UltragazEmpresarial:refreshToken');
  }

  return {
    getService,
    clearStorage,
    setToken,
    getAccessToken,
    getRefreshToken,
  };
})();

export default localStorageService;
